"use client";

import { useEffect, useRef, useState } from "react";
import { ticker } from "@/content";

/** Mock live ticker: counts up once, then drifts gently. Static under reduced motion. */
export default function Ticker() {
  const [players, setPlayers] = useState(ticker.players);
  const [worlds, setWorlds] = useState(ticker.worlds);
  const started = useRef(false);

  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced || started.current) return;
    started.current = true;

    const t0 = performance.now();
    const D = 1600;
    let raf = 0;
    const tick = (t: number) => {
      const p = Math.min(1, (t - t0) / D);
      const eased = 1 - Math.pow(1 - p, 3);
      setPlayers(Math.round(ticker.players * eased));
      setWorlds(Math.max(1, Math.round(ticker.worlds * eased)));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);

    const drift = setInterval(() => {
      setPlayers((n) => Math.max(50, n + Math.round((Math.random() - 0.45) * 9)));
      if (Math.random() < 0.06) {
        setWorlds((n) => Math.min(12, Math.max(4, n + (Math.random() < 0.5 ? -1 : 1))));
      }
    }, 4200);

    return () => {
      cancelAnimationFrame(raf);
      clearInterval(drift);
    };
  }, []);

  return (
    <p className="inline-flex items-center gap-2.5 rounded-full border border-ink-600/80 bg-ink-950/70 px-4 py-1.5 text-sm text-parch-200">
      <span className="relative flex h-2 w-2" aria-hidden="true">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-moss-400 opacity-60 motion-reduce:hidden" />
        <span className="relative inline-flex h-2 w-2 rounded-full bg-moss-400" />
      </span>
      <span>
        {ticker.label}:{" "}
        <strong className="font-semibold text-parch-100 tabular-nums">
          {players.toLocaleString("en-US")}
        </strong>{" "}
        players in{" "}
        <strong className="font-semibold text-parch-100 tabular-nums">{worlds}</strong> worlds
      </span>
    </p>
  );
}
